import RoiCalculator from "./roi-calculator-view";

export default RoiCalculator;
